import React, { FC, ReactElement, ReactNode, Ref, useRef, useState } from 'react'

import { ReactState } from '../../Contexts'
import Icon, { IconName } from '../Icon'
import PopperBubble from '../PopperBubble'

type Props = {
    text: string | ReactElement
    children?: ReactNode
}

/**
 * Input help, creates a help tooltip icon next to the input box.
 *
 * @param text - The text to display.
 * @param children - The input that this help is attached to.
 */
export const InputHelp: FC<Props> = ({ text, children }: Props): ReactElement => {
    const iconRef: Ref<HTMLDivElement> = useRef(null)
    const [open, setOpen]: ReactState<boolean> = useState<boolean>(false)

    return (
        <div className='input-help-container'>
            {children}
            <div
                className='ihc-mouse-over-area'
                onMouseOver={(): void => setOpen(true)}
                onMouseOut={(): void => setOpen(false)}
            >
                <Icon inputRef={iconRef} iconName={IconName.HELP} />
            </div>

            <PopperBubble
                className='ihc-popper'
                content={<>{text}</>}
                anchorEl={iconRef.current}
                placement='top'
                open={open}
                infoMode
            />
        </div>
    )
}
